import { render } from "./SelectGames.vue?vue&type=template&id=34c8843c&scoped=true"
import script from "./SelectGames.vue?vue&type=script&lang=js"
export * from "./SelectGames.vue?vue&type=script&lang=js"

import "./SelectGames.vue?vue&type=style&index=0&id=34c8843c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c8843c"]])

export default __exports__